// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_5b10bb2305--overlay--aFS5j","preloader":"_5b10bb2305--preloader--rTTf6"};